var React = require('react');

function IcSmarttv (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 4H4C2.3 4 1 5.3 1 7V23C1 24.7 2.3 26 4 26H10V30H22V26H28C29.7 26 31 24.7 31 23V7C31 5.3 29.7 4 28 4ZM15 12H12V20H10V12H7V10H15V12ZM21.7 20H19.3L16 10H18.1L20.5 17.3L22.9 10H25L21.7 20Z","fill":"currentColor"}));
}

IcSmarttv.defaultProps = {"id":"ic-smarttv","viewBox":"0 0 32 32","fill":"none"};

module.exports = IcSmarttv;

IcSmarttv.default = IcSmarttv;
